import { Unit } from "./Unit";
import { UnitGroup } from "./UnitGroup";

export class WeightUnits extends UnitGroup {
    private static _singleton: WeightUnits;

    public static readonly KILOGRAM = new Unit("KG", "Kilograms");
    public static readonly POUND = new Unit("LB", "Pounds");
    
    constructor() {
        const units = [ WeightUnits.KILOGRAM, WeightUnits.POUND ];
        super(units, "weight_company_um", "weight_functional_um");
    }

    public static get singleton(): WeightUnits {
        if (this._singleton == null) {
            this._singleton = new WeightUnits();
        }
        return this._singleton;
    }
}
